import {
  DateField,
  useRecordContext,
  RecordContextProvider,
  NumberField,
  TabbedShowLayout,
  useTranslate,
  TextField,
} from "react-admin";
import Box from "@mui/material/Box";
import { Fragment } from "react";

const SecondTable = ({ t, customerDebtPaymentItems, total }) => {
  return (
    <Box
      component="table"
      sx={{
        width: "40%",
        margin: "auto",
        // bgcolor: "rgba(0,0,0,.04)",
        // fontSize: "smaller",
        borderCollapse: "collapse",
        "& th, td": {
          padding: "6px 8px",
          border: "1px solid #dddddd",
        },
      }}
    >
      <thead>
        <tr>
          <th>No. Surat Jalan</th>
          <th style={{ textAlign: "right" }}>Jumlah Bayar</th>
        </tr>
      </thead>
      <tbody>
        {customerDebtPaymentItems.map((item, idx) => {
          return (
            <tr key={item.id + idx}>
              <td>{item.sale.code}</td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={item}>
                  <NumberField
                    source="amount"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
            </tr>
          );
        })}
        <tr>
          <td colSpan={2} style={{ textAlign: "right" }}>
            <RecordContextProvider value={{ total }}>
              <NumberField
                source="total"
                sx={{
                  fontSize: "inherit",
                  fontWeight: 700,
                }}
              />
            </RecordContextProvider>
          </td>
        </tr>
      </tbody>
    </Box>
  );
};

const ReceivedCheckExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <TabbedShowLayout
      syncWithLocation={false}
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <TabbedShowLayout.Tab label="mine.label.payment">
        <Box
          component="table"
          sx={{
            width: "100%",
            // bgcolor: "rgba(0,0,0,.04)",
            // fontSize: "smaller",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "6px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>{t("mine.label.code")}</th>
              <th>{t("mine.label.transaction_date")}</th>
              <th>{t("mine.label.due_date")}</th>
              <th>{t("mine.label.check_number")}</th>
              <th>No. Lunas/Batal</th>
              <th>Tgl. Lunas/Batal</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {record.customer_debt_payments.map((item, idx) => {
              return (
                <Fragment key={item.id + idx}>
                  <tr>
                    <td>{item.payment_code}</td>
                    <td>
                      <RecordContextProvider value={item}>
                        <DateField
                          source="received_date"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td>
                      <RecordContextProvider value={item}>
                        <DateField
                          source="effective_date"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td>
                      <RecordContextProvider value={item}>
                        <TextField
                          source="check_number"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td>
                      <RecordContextProvider value={item}>
                        <TextField
                          source="check_cashing.code"
                          emptyText="-"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td>
                      <RecordContextProvider value={item}>
                        <DateField
                          source="check_cashing.date"
                          emptyText="-"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <RecordContextProvider value={item}>
                        <NumberField
                          source="total"
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7}>
                      <SecondTable
                        t={t}
                        customerDebtPaymentItems={
                          item.customer_debt_payment_items
                        }
                        total={item.total}
                      />
                    </td>
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Box>
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  );
};

export default ReceivedCheckExpandList;
